import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteHotelBidFailureLogs, retryHotelBidFailures } from '~/services/PublicOfferFeedService';

import { hotelBidFailureLogQueryKeys } from './useGetHotelBidFailureLogs';

export function useRetryHotelBidFailures() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ customerId, ids }: { customerId: string; ids: Array<string> }) =>
      retryHotelBidFailures(customerId, ids),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: hotelBidFailureLogQueryKeys.all });
    },
  });
}

export function useDeleteHotelBidFailureLogs() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ customerId, ids }: { customerId: string; ids: Array<string> }) =>
      deleteHotelBidFailureLogs(customerId, ids),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: hotelBidFailureLogQueryKeys.all });
    },
  });
}
